"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transferServicesDataRequested = transferServicesDataRequested;
exports.transferServicesDataReceived = transferServicesDataReceived;
exports.transferServicesDataRequestFailed = transferServicesDataRequestFailed;
var TRANSFER_SERVICES_DATA_REQUESTED = exports.TRANSFER_SERVICES_DATA_REQUESTED = "TRANSFER_SERVICES_DATA_REQUESTED";

function transferServicesDataRequested() {
    return {
        type: TRANSFER_SERVICES_DATA_REQUESTED
    };
}

var TRANSFER_SERVICES_DATA_RECEIVED = exports.TRANSFER_SERVICES_DATA_RECEIVED = "TRANSFER_SERVICES_DATA_RECEIVED";

function transferServicesDataReceived(transferServiceData) {
    return {
        type: TRANSFER_SERVICES_DATA_RECEIVED,
        transferServiceData: transferServiceData
    };
}

var TRANSFER_SERVICES_DATA_REQUEST_FAILED = exports.TRANSFER_SERVICES_DATA_REQUEST_FAILED = "TRANSFER_SERVICES_DATA_REQUEST_FAILED";

function transferServicesDataRequestFailed(error) {
    return {
        type: TRANSFER_SERVICES_DATA_REQUEST_FAILED,
        error: error
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/transferServicesDataActions.js
// module id = 205
// module chunks = 0